import { useState } from "react";
import {
  SelectDrawer,
  SelectDrawerBodyListRadio,
  SelectDrawerBodySingleList,
  type SelectDrawerItemProps,
  SelectDrawerSearch,
} from "@/components/select-drawer";

interface InternationalPhoneSelectFlagDrawerProps {
  items: SelectDrawerItemProps<string>[];
  value: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onChange?: (value: string) => void;
}

export const InternationalPhoneSelectFlagDrawer = ({
  items,
  value,
  open,
  onOpenChange,
  onChange,
}: InternationalPhoneSelectFlagDrawerProps): JSX.Element => {
  const initialSelectedItem = items.find((x) => x.value === value);
  const [searchResults, setSearchResults] =
    useState<SelectDrawerItemProps<string>[]>(items);

  const handleItemSelected = (
    newValue: SelectDrawerItemProps<string> | undefined,
  ): void => {
    if (newValue && newValue !== initialSelectedItem) {
      if (onChange) {
        onChange(newValue.value);
      }
      onOpenChange(false);
    }
  };

  return (
    <SelectDrawer open={open} setOpen={onOpenChange}>
      <SelectDrawerSearch items={items} onSearch={setSearchResults} />
      <SelectDrawerBodySingleList
        initialSelectedItem={initialSelectedItem}
        setSelectedItem={handleItemSelected}
      >
        {searchResults.map((item) => (
          <SelectDrawerBodyListRadio
            value={item.value}
            key={`searchResult-${item.label}-${item.value}`}
          >
            {item.label}
          </SelectDrawerBodyListRadio>
        ))}
      </SelectDrawerBodySingleList>
    </SelectDrawer>
  );
};
